import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { generatePath, Route, Switch, useParams } from 'react-router-dom'
import { isFulfilled } from '@reduxjs/toolkit'
import { push } from 'connected-react-router'

import FacebookEditor from '../../components/PostCreation/PostEditor/Facebook'
import TwitterEditor from '../../components/PostCreation/PostEditor/Twitter'
import LinkedinEditor from '../../components/PostCreation/PostEditor/Linkedin'
import InstagramEditor from '../../components/PostCreation/PostEditor/Instagram'

import SocialPosts from '../../components/PostCreation/SocialPosts'
import ChangeView from '../../components/ToggleMobileDesktopView'
import FeaturesTooltip from '../../components/PostCreation/FeaturesTooltip'
import PostConversation from '../../components/PostCreation/PostConversation'
import { AUTH_ROUTE } from '../App/routes'
import { PostRestrictionHandler } from '../../utils/postCreationHandler'

import { useDispatch, useSelector } from '../../store'
import {
  setPostTypeAction,
  resetManagePostStateAction,
  setSelectedSocialsAction,
  setSelectedSocialAction,
  removeAttachmentFromListAction,
  addImageToStoreAction,
  changeAttachmentExtrafieldAction,
  addLinkToSocialAttachmentAction,
  addImageToLinkAttachmentAction,
  removeImageFromLinkAttachmentAction,
  setLinkCarouselSelectedAttachmentIdsAction,
  setSelectedPostSocialIdAction,
  addThumbnailToAttachmentAction,
  setIsAutopostingAction
} from '../../store/managePost/slice'
import {
  addMediaToTemporaryMediasThunk,
  getPostThunk,
  importTemporaryMediaFromCanva,
  checkMediaRestrictionsThunk,
  checkMediaRestrictionsForCopyDataToSocialPostsThunk
} from '../../store/managePost/thunks'
import { getPostApprovalInfoThunk, showAllPostSocialNoteThunk } from '../../store/managePost/thunks'
import {
  setEmptyPostSocialsAction,
  setViewAction,
  onFieldChangeAction
} from '../../store/managePost/slice'
import { hideGlobalPreloaderAction, showGlobalPreloaderAction } from '../../store/preloader/slice'
import {
  createEmptyPostSocialsBySelectedSocials,
  TAttachmentIds,
  TChangeAttachmentExtrafieldPayload,
  TFieldChangePayload,
  TImportCanvaPayload,
  TPostSocialManagePost,
  TRemoveAttachmentPayload,
  VIEW_TYPE
} from '../../store/managePost/newTypes'
import {
  MEDIA_DATA_TYPE,
  POST_SOCIAL_STATUS,
  POST_STATUS,
  POST_TYPE,
  SOCIAL_NETWORK
} from '../../models/post'
import { ImageType } from 'react-images-uploading'

import { TCanvaPayload } from '../../components/PostCreation/CanvaButton/CanvaButton'
import CustomButton from '../../components/UI/Buttons/CustomButton'
import DublicateIcon from '../../components/UI/Icons/Dublicate'
import CustomPopup from '../../components/UI/Popup'
import ConfirmPopup from '../../components/UI/ConfirmPopup'
import {
  hideTransparentPreloaderAction,
  showTransparentPreloaderAction
} from '../../store/transparentPreloader/slice'
import { useToasts } from 'react-toast-notifications'
import { TOAST_MESSAGE } from '../../components/UI/ToastNotification/ToastNotification'
import './CreatePost.scss'
import { selectSocialMediaDataBySocialName } from '../../selectors/ProjectSelector'
import { defineAvailablePostsActions } from '../../models/postStatuses'
import { getPostsForInstaGridViewThunk } from '../../store/gridView/thunks'
import InstagramGrid from '../../components/PostCreation/GridPosts/Instagram'
import { resetGridViewStateAction } from '../../store/gridView/slice'
import { getPublishDate } from '../../utils/transformSchedule'
import HashtagDarkIcon from '../../components/UI/Icons/HashtagDark';
import { toggleHashtagListModal } from '../../store/hashtag/slice';

interface CreateAgencyProps { }

export type TMediaCallbacks = {
  addImage: () => void
  addVideo: () => void
  startEditLink: (isFocusInput: boolean) => void
  addChildLink: () => void
  addCanvaImage: (payload: TCanvaPayload) => void
}

const CreatePost: FC<CreateAgencyProps> = (props) => {
  const dispatch = useDispatch()
  const {
    selectedSocial,
    schedule,
    project,
    location,
    postSocialsNotes,
    view,
    postSocials,
    postStatus,
    postType,
    postId,
    loaders,
    linkCarouselSelectedAttachmentIds,
    isGettingPostError,
    gridPosts,
    socialDetails
  } = useSelector((state) => ({
    schedule: state.managePost.latestSchedule,
    project: state.project.currentProject,
    location: state.router.location,
    view: state.managePost.viewType,
    postSocials: state.managePost.postSocials,
    postStatus: state.managePost.post.status,
    postId: state.managePost.post.id,
    postType: state.managePost.selectedPostType,
    selectedSocial: state.managePost.selectedSocial,
    postSocialsNotes: state.managePost.postSocialNotes,
    selectedPostSocialId: state.managePost.selectedPostSocialId,
    linkCarouselSelectedAttachmentIds: state.managePost.linkCarouselSelectedAttachmentIds,
    isGettingPostError: state.managePost.isGettingPostError,
    loaders: state.managePost.loaders,
    gridPosts: state.gridView[SOCIAL_NETWORK.INSTAGRAM_SOCIAL].latestPosts,
    socialDetails: selectSocialMediaDataBySocialName(state)
  }))
  const { social }: { social: SOCIAL_NETWORK } = useParams()
  const locationPostId = (location as any).query.postId

  const setCarouselActiveAttachmentIds = (data: TAttachmentIds) => {
    dispatch(setLinkCarouselSelectedAttachmentIdsAction(data))
  }
  const { addToast } = useToasts()

  const refMediaCallbaks = useRef<TMediaCallbacks>({
    addImage: () => { },
    addVideo: () => { },
    startEditLink: () => { },
    addChildLink: () => { },
    addCanvaImage: () => { }
  })
  const [isCopyModalOpen, setIsCopyModalOpen] = useState<boolean>(false)
  const restrictions = useMemo(() => {
    return new PostRestrictionHandler({ social: selectedSocial, postType }).getContentRestrictions()
  }, [selectedSocial, postType])

  const [socialNetwork, setSocialNetwork] = useState<string>('');
  useEffect(() => {
    setSocialNetwork(selectedSocial);
  }, [selectedSocial]);

  const checkMediaRestrictions = async (media_id: number, isThumbnail?: boolean) =>
    await dispatch(
      checkMediaRestrictionsThunk({
        media_id,
        social_options: [
          {
            post_social_type: !isThumbnail ? postType : POST_TYPE.POST_TYPE_SINGLE_PHOTO,
            social_network_name: selectedSocial
          }
        ]
      })
    )

  const addMediaToTemporaryDataAndCheckRestrictions = async (
    image: ImageType,
    isThumbnail?: boolean
  ) => {
    let result = null
    dispatch(showTransparentPreloaderAction())
    const data = new FormData()
    data.append('media', image.file!)
    const responseAddMedialToPost = await dispatch(addMediaToTemporaryMediasThunk(data))
    if (isFulfilled(responseAddMedialToPost)) {
      const mediaData: MEDIA_DATA_TYPE = responseAddMedialToPost.payload.data
      const responseCheckMediaRestrictions = await checkMediaRestrictions(mediaData.id, isThumbnail)
      if (isFulfilled(responseCheckMediaRestrictions)) {
        result = mediaData
      }
    }
    dispatch(hideTransparentPreloaderAction())
    return result
  }

  useEffect(() => {
    const activePostSocial = postSocials.find((socialPost) => socialPost.social_network === social)
    dispatch(setSelectedPostSocialIdAction(activePostSocial ? activePostSocial.id : 0))
  }, [social, postSocials.length])

  const runActionAddAttachmentDependOfPostType = (
    media: MEDIA_DATA_TYPE,
    postIds?: TAttachmentIds
  ) => {
    switch (postType) {
      case POST_TYPE.POST_TYPE_LINK_CAROUSEL: {
        return dispatch(addImageToLinkAttachmentAction({ media, ...postIds! }))
      }
      default: {
        return dispatch(addImageToStoreAction(media))
      }
    }
  }

  const addMediaToTemporaryLibrary = async (image: ImageType, postIds?: TAttachmentIds) => {
    if (image.file) {
      const mediaData = await addMediaToTemporaryDataAndCheckRestrictions(image)
      if (!!mediaData) {
        addToast(TOAST_MESSAGE.CHANGE_SAVED, { appearance: 'success' })
        runActionAddAttachmentDependOfPostType(mediaData, postIds)
      } else {
        addToast(TOAST_MESSAGE.GENERAL_ERROR_MASSEGE, { appearance: 'error' })
        console.error('___ CHECKING RESTRICTIONS WAS FAILLURED ___ , ', mediaData)
      }
    }
  }

  const addThumbnailToAttachment = async (image: ImageType, attachmentIds: TAttachmentIds) => {
    if (image.file) {
      const mediaData = await addMediaToTemporaryDataAndCheckRestrictions(image, true)
      if (!!mediaData) {
        dispatch(addThumbnailToAttachmentAction({ media: mediaData, ...attachmentIds }))
      } else {
        console.error('___ CHECKING RESTRICTIONS WAS FAILLURED ___ , ', mediaData)
      }
    }
  }

  const setExtraField = (data: TChangeAttachmentExtrafieldPayload) => {
    dispatch(changeAttachmentExtrafieldAction(data))
  }

  const updateCanvaImage = async (
    { exportUrl: content_url, designId: canva_design_id }: TCanvaPayload,
    index?: number
  ) => {
    const payload: TImportCanvaPayload = {
      content_url,
      canva_design_id
    }
    await dispatch(importTemporaryMediaFromCanva(payload))
  }

  const deattachAttachment = (data: TRemoveAttachmentPayload) =>
    dispatch(removeAttachmentFromListAction(data))

  const removeMediaFromAttachments = (data: TRemoveAttachmentPayload) => {
    switch (postType) {
      case POST_TYPE.POST_TYPE_LINK_CAROUSEL: {
        return dispatch(removeImageFromLinkAttachmentAction(data))
      }
      default: {
        return deattachAttachment(data)
      }
    }
  }

  const moveTo = (path: string) => dispatch(push(path))

  const changeView = (view: VIEW_TYPE): void => {
    dispatch(setViewAction(view))
  }

  const onTextChange = (data: TFieldChangePayload): void => {
    dispatch(onFieldChangeAction(data))
  }

  useEffect(() => {
    if (postId && postSocials.length) {
      const getAllPostSocialsNotes = async () => {
        return postSocials.map(async ({ id }) => {
          if (!postSocialsNotes[id]) await dispatch(showAllPostSocialNoteThunk(id))
        })
      }
      getAllPostSocialsNotes()
    }
  }, [postSocials, postId, postSocialsNotes])

  useEffect(() => {
    if (locationPostId) {
      const getPostAndApprovalPlan = async () => {
        dispatch(showGlobalPreloaderAction())
        const responseGetPost = await dispatch(getPostThunk(locationPostId))

        if (
          isFulfilled(responseGetPost) &&
          responseGetPost.payload.data.status !== POST_STATUS.STATUS_DRAFT &&
          responseGetPost.payload.data.status !== POST_STATUS.STATUS_TEMPORARY_DRAFT
        ) {
          const responseGetPostApprovalInfo = await dispatch(
            getPostApprovalInfoThunk(locationPostId)
          )
        }
        dispatch(hideGlobalPreloaderAction())
      }
      getPostAndApprovalPlan()
    } else {
      // set data when post is creating
      const socials = (location as any).query.socials
      const type = (location as any).query.type
      const arrOfSocials = socials
        .split(',')
        .map((social: SOCIAL_NETWORK) => social)
        .filter((urlSocial: string) =>
          Object.values(SOCIAL_NETWORK).some((social) => social === urlSocial)
        )

      if (type) dispatch(setPostTypeAction(type))
      if (socials) dispatch(setSelectedSocialsAction(arrOfSocials))
      if (socials && type) {
        const emptyPostSocials = createEmptyPostSocialsBySelectedSocials(arrOfSocials, type)
        dispatch(setEmptyPostSocialsAction(emptyPostSocials))

        const difineIsDisableAutoposting = defineAvailablePostsActions
          .autoposting(type, arrOfSocials)
        difineIsDisableAutoposting && dispatch(setIsAutopostingAction(false))
      }
    }
    dispatch(setSelectedSocialAction(social))

    return () => {
      dispatch(resetManagePostStateAction())
      dispatch(resetGridViewStateAction())
    }
    // eslint-disable-next-line
  }, [dispatch])

  const generatePathToSocial = (social: SOCIAL_NETWORK) =>
    generatePath(AUTH_ROUTE.MANAGE_POST, {
      projectId: project.id,
      social
    })

  const selectedPostSocial: TPostSocialManagePost | null = useMemo(() => {
    const socialPost = postSocials.find(({ social_network }) => selectedSocial === social_network)
    return socialPost
      ? {
        ...socialPost,
        type: postType,
        attachments: socialPost.attachments.filter((media) => !media.toRemove),
        isEditable:
          socialPost.status === POST_SOCIAL_STATUS.STATUS_DRAFT ||
          socialPost.status === POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION ||
          socialPost.status === POST_SOCIAL_STATUS.STATUS_PENDING_INTERNAL_APPROVAL ||
          socialPost.status === POST_SOCIAL_STATUS.STATUS_PENDING_EXTERNAL_APPROVAL ||
          socialPost.status === POST_SOCIAL_STATUS.STATUS_SCHEDULED

      }
      : null
  }, [selectedSocial, postSocials])

  const isStory = useMemo(
    () =>
      postType === POST_TYPE.POST_TYPE_PHOTO_STORY || postType === POST_TYPE.POST_TYPE_VIDEO_STORY,
    [postType]
  )

  const isReels = useMemo(
    () =>
      postType === POST_TYPE.POST_TYPE_REELS,
    [postType]
  )

  const showCopyModal = () => setIsCopyModalOpen(true)
  const closeCopyModal = () => setIsCopyModalOpen(false)

  const showHashtagModal = () => dispatch(toggleHashtagListModal())

  const copyPostSocialContentToOtherSocials = async () => {
    await dispatch(checkMediaRestrictionsForCopyDataToSocialPostsThunk())
    closeCopyModal()
  }

  const addLinkToAttachments = (isChildLink: boolean) => {
    dispatch(addLinkToSocialAttachmentAction({ isChildLink }))
  }

  const selectedLinkCarouselAttachment = useMemo(() => {
    const { id, temporaryId } = linkCarouselSelectedAttachmentIds
    if (
      (id || temporaryId) &&
      selectedPostSocial &&
      postType === POST_TYPE.POST_TYPE_LINK_CAROUSEL
    ) {
      const foundedAttachment = selectedPostSocial.attachments.find(
        (attachment) =>
          (!!id && attachment.id === id) ||
          (!!temporaryId && attachment.temporaryId === temporaryId)
      )
      return foundedAttachment || null
    }
    return null
  }, [linkCarouselSelectedAttachmentIds, postType])

  const socialsWithFilteredAttachments = useMemo(
    () =>
      postSocials.map((socialPost) => ({
        ...socialPost,
        attachments: socialPost.attachments.filter(({ toRemove }) => !toRemove)
      })),
    [postSocials]
  )

  const previewSocialProps = {
    project,
    location,
    postSocials: socialsWithFilteredAttachments,
    restrictions,
    isStory,
    isReels
  }

  // Grid view
  const isEnableGridView = useMemo(() => {
    switch (selectedSocial) {
      case SOCIAL_NETWORK.INSTAGRAM_SOCIAL: {
        return true
      }
      default: {
        return false
      }
    }
  }, [selectedSocial])

  useEffect(() => {
    const getPostsForGridView = async () => {
      switch (selectedSocial) {
        case SOCIAL_NETWORK.INSTAGRAM_SOCIAL: {
          await dispatch(getPostsForInstaGridViewThunk())
        }
      }
    }

    if (!gridPosts.length && isEnableGridView) {
      getPostsForGridView()
    }

    if (selectedSocial !== SOCIAL_NETWORK.INSTAGRAM_SOCIAL && view === VIEW_TYPE.TYPE_GRID) {
      dispatch(setViewAction(VIEW_TYPE.TYPE_DESKTOP))
    }
  }, [selectedSocial, view])

  const isShowCopyButton = useMemo(
    () => postSocials.length > 1 && defineAvailablePostsActions.copyContentToOtherSM(postStatus),
    [postSocials.length, selectedPostSocial, postStatus]
  )

  const publishDate = useMemo(() => getPublishDate(schedule), [schedule])

  const [postValue, setPostValue] = useState('');
  const [getTypedHashtagValue, setTypedHashtagValue] = useState<any>('');
  const [getTypedMentionValue, setTypedMentionValue] = useState<any>('');
  const [postMentionValues, setPostMentionValues] = useState<any>([]);
  const [postGeolocationValue, setPostGeolocationValue] = useState<string>();

  const editorProps = {
    onTextChange,
    refMediaCallbaks,
    isStory,
    socialDetails,
    view,
    addMediaToTemporaryLibrary,
    deleteMediaFromPostSocial: removeMediaFromAttachments,
    setExtraField,
    restrictions,
    post: selectedPostSocial,
    addLinkToAttachments,
    gridPosts,
    postValue,
    setPostValue,
    getTypedHashtagValue,
    getTypedMentionValue,
    postMentionValues,
    setPostMentionValues,
    postGeolocationValue,
    setPostGeolocationValue,
    isReels
  }

  const featuresProps = {
    attachmentsLength: selectedPostSocial?.attachments.length,
    refMediaCallbaks,
    restrictions,
    addMediaToTemporaryLibrary,
    onUpdateCanvaImage: updateCanvaImage,
    activeAttachment: selectedLinkCarouselAttachment,
    socialNetwork,
    setPostValue,
    setTypedHashtagValue,
    setTypedMentionValue,
    setPostMentionValues,
    setPostGeolocationValue,
    post_type: selectedPostSocial?.type
  }

  return !isGettingPostError ? (
    <>
      <div className='posts-creation__content__preview-posts'>
        <SocialPosts {...previewSocialProps} />
      </div>
      <div className='posts-creation__content__workground'>
        <div className='posts-creation__content__workground__change-view'>
          <ChangeView changeView={changeView} view={view} isEnableGridView={isEnableGridView} />
        </div>
        <div className='posts-creation__content__workground__post'>
          {selectedPostSocial && (
            <div className={`edit-post ${view}-editor`}>
              {isShowCopyButton && (
                <div className='edit-post__copy-button-wrapper'>
                  <CustomPopup
                    position='top center'
                    on='hover'
                    className='post-creation-popup'
                    offsetX={10}
                    offsetY={10}
                    trigger={() => (
                      <div>
                        <CustomButton
                          onClick={showCopyModal}
                          button='main'
                          className='edit-post__copy-button-wrapper__button'
                        >
                          <DublicateIcon />
                        </CustomButton>
                      </div>
                    )}
                  >
                    Copy content <br /> to other SM
                  </CustomPopup>
                </div>
              )}
                <div className='edit-post__hashtag-button-wrapper'>
                  <CustomPopup
                    position='top center'
                    on='hover'
                    className='post-creation-popup'
                    offsetX={10}
                    offsetY={10}
                    trigger={() => (
                      <div>
                        <CustomButton
                          onClick={showHashtagModal}
                          button='main'
                          className='edit-post__hashtag-button-wrapper__button'
                        >
                          <HashtagDarkIcon />
                        </CustomButton>
                      </div>
                    )}
                  >
                    Copy from <br /> Hashtag Pool
                  </CustomPopup>
                </div>
              <Switch>
                <Route path={generatePathToSocial(SOCIAL_NETWORK.FACEBOOK_SOCIAL)}>
                  <FacebookEditor
                    {...editorProps}
                    publishDate={publishDate[SOCIAL_NETWORK.FACEBOOK_SOCIAL]}
                    post={selectedPostSocial}
                    addThumbnailToAttachment={addThumbnailToAttachment}
                    linkCarouselSelectedAttachmentIds={linkCarouselSelectedAttachmentIds}
                    setCarouselActiveAttachmentIds={setCarouselActiveAttachmentIds}
                    deattachAttachment={deattachAttachment}
                  />
                </Route>
                <Route path={generatePathToSocial(SOCIAL_NETWORK.INSTAGRAM_SOCIAL)}>
                  {view !== VIEW_TYPE.TYPE_GRID ? (
                    <InstagramEditor
                      {...editorProps}
                      publishDate={publishDate[SOCIAL_NETWORK.INSTAGRAM_SOCIAL]}
                      post={selectedPostSocial}
                    />
                  ) : (
                    <InstagramGrid {...{ socialDetails, posts: gridPosts }} />
                  )}
                </Route>
                <Route path={generatePathToSocial(SOCIAL_NETWORK.LINKEDIN_SOCIAL)}>
                  <LinkedinEditor
                    {...editorProps}
                    publishDate={publishDate[SOCIAL_NETWORK.LINKEDIN_SOCIAL]}
                    post={selectedPostSocial}
                  />
                </Route>
                <Route path={generatePathToSocial(SOCIAL_NETWORK.TWITTER_SOCIAL)}>
                  <TwitterEditor
                    {...editorProps}
                    publishDate={publishDate[SOCIAL_NETWORK.TWITTER_SOCIAL]}
                    post={selectedPostSocial}
                  />
                </Route>
              </Switch>
            </div>
          )}
          {selectedPostSocial && selectedPostSocial.isEditable && view !== VIEW_TYPE.TYPE_GRID && (
            <FeaturesTooltip {...featuresProps} />
          )}
          <ConfirmPopup
            onClose={closeCopyModal}
            onConfirm={copyPostSocialContentToOtherSocials}
            isModalOpen={isCopyModalOpen}
            isInProgress={loaders.post.copyAttachments}
          >
            Are you sure you want to copy the content to other socials?
          </ConfirmPopup>
        </div>
      </div>
      <div className='posts-creation__content__chat'>
        <PostConversation />
      </div>
    </>
  ) : (
    <div className='post-creation__post-is-not-existed'>
      The post id={locationPostId || postId} does not exist.
    </div>
  )
}

export default CreatePost
